// extracted by mini-css-extract-plugin
module.exports = {"Chart":"categories-bar-chart_Chart__38Saj"};